import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { TasksService } from 'src/app/business-service/tasks/tasks.service';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { VoucherService } from 'src/app/business-service/voucher/voucher.service';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { PersonOptionsComponent } from '../../shared/popover/person-options/person-options.component';
import { CONTACT_TYPES, RECORD_STATUS_VALUES, TABLE_OPTION_VALUES, TRAVEL_SERVICES } from '../../shared/constants/api-constants';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { VisaService } from 'src/app/business-service/visa/visa.service';
import { EmailpopupComponent } from '../../inventory-itinerary/add/email/emailpopup/emailpopup.component';
import { CallsService } from 'src/app/business-service/calls/calls.service';
import { FirebaseDatabaseService } from '../../shared/services/firebase-database/firebase-database.service';
import { PdfService } from '../../shared/services/pdf.service';

@Component({
  selector: 'app-lead-details',
  templateUrl: './lead-details.component.html',
  styleUrls: ['./lead-details.component.scss'],
})
export class LeadDetailsComponent implements OnInit {
  leadDetails: any;
  @Input() leadIdUrl: any;

  leadForVisa: boolean = false;

  @ViewChild('newLeadNote') newLeadNote!: ElementRef;

  quoteDetails: any;
  packageIds: any;
  onlyWebsite: any;
  showCreateQuoteButton: boolean = true;
  showVouchers: boolean = false;
  showEditButton: any;

  allLeadItinerarys: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };
  allLeadItineraryColumns: any = [
    { key: "itineraryId", colName: "Quote ID", showColumn: true },
    { key: "leadId", colName: "Lead ID", showColumn: false },
    { key: "leadName", colName: "Lead Name", showColumn: false },
    { key: "destination", colName: "Destination", showColumn: true },
    { key: "totalDays", colName: "Nights", showColumn: true },
    { key: "travelDate", colName: "Travel Date", showColumn: true },
    { key: "totalAdults", colName: "Travelers", showColumn: true },
    { key: "tourPackageAmount", colName: "Amount", showColumn: true },
    { key: "status", colName: "Status", showColumn: true },
    { key: "createdBy", colName: "Created By", showColumn: true },
    { key: "createDate", colName: "Created Date", showColumn: true }
  ]

  allLeadTasks: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };;

  // Client specific sections
  clientVouchers: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };
  showInvoiceSection: any;
  hideTaskView: any;
  hideCreateTask: any;

  clinentVouchersColumsn: any = [
    { key: "voucherId", colName: "ID", showColumn: true, emitRowOnClick: true },
    { key: "itineraryId", colName: "Quote ID", showColumn: true, emitRowOnClick: true },
    { key: "createDate", colName: "Created Date", showColumn: true, formatter: "date" },
    { key: "status", colName: "Status", showColumn: true }
  ]
  vouchersOptionsValues: any =
    {
      idKey: 'voucherId',
      options: [
        {
          value: "View",
          path: "details"
        },
        {
          value: "Edit",
          path: "edit"
        },
        {
          value: "Delete",
          path: "delete"
        }
      ]
    }

  
  leadGuestColumns: any = [
    { key: "contactId", colName: "ID", showColumn: true },
    { key: "firstName", colName: "Name", showColumn: true },
    { key: "phoneNumber", colName: "Phone Number", showColumn: true },
    { key: "age", colName: "Age", showColumn: true },
    { key: "gender", colName: "gender", showColumn: true },
    { key: "documents", colName: "Documents", showColumn: true },
  ]

  guestsOptionsValues: any =
    {
      idKey: 'guestId',
      options: [
        {
          value: "View",
          path: "details"
        },
        {
          value: "Edit",
          path: "edit"
        },
        {
          value: "Delete",
          path: "delete"
        }
      ]
    }

  leadTaskColumns: any = [
    { key: "taskId", colName: "ID", showColumn: true, routePath: '/tasks/details/' },
    { key: "dueDate", colName: "Due Date", showColumn: true, formatter: 'date' },
    { key: "ownershipName", colName: "Assigned To", showColumn: true },
    { key: "subject", colName: "Subject", showColumn: true },
    { key: "priority", colName: "Priority", showColumn: true },
  ]

  tasksOptionsValues: any =
    {
      idKey: 'taskId',
      options: [
        {
          value: "View",
          path: "details"
        },
        {
          value: "Edit",
          path: "edit"
        },
        {
          value: "Delete",
          path: "delete"
        }
      ]
    }

  taskStatusLov: any;

  // lead of client
  allLeadsOfClient: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };

  allDmcVendorsEmails: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };


  leadsOfClientColumns: any = [
    { key: "leadId", colName: "Lead ID", showColumn: true, routePath: "/clients/lead/" },
    { key: "itineraryId", colName: "Quote ID", showColumn: true, emitRowOnClick: true },
    { key: "createDate", colName: "Created Date", showColumn: true, formatter: "date" },
    { key: "ownershipName", colName: "Assigned To", showColumn: true },
    { key: "travelServices", colName: "Service Type", showColumn: true },
    { key: "destinations", colName: "Destinations", showColumn: true },
    { key: "source", colName: "Source", showColumn: true },
    { key: "status", colName: "Status", showColumn: true }
  ]


  VendorDmcColumns: any = [
    { key: "organizationName", colName: "DMC / Vendor Name", showColumn: true },
    { key: "destination", colName: "Destination", showColumn: true },
    { key: "fromEmail", colName: "Send By", showColumn: true },
    { key: "status", colName: "Status", showColumn: true, emitRowOnClick: true },
    { key: "createDate", colName: "Date", showColumn: true, formatter: "date" },
  ]

  // calls of lead
  allCallsOfLead: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };
  callsOfLeadsColumns: any = [
    { key: "contact", colName: "Contact Name", showColumn: true },
    { key: "number", colName: "Number", showColumn: true },
    { key: "type", colName: "Type", showColumn: true, },
    { key: "date", colName: "Date", showColumn: true, formatter: "date: MMM d, yyyy - h:mm a" },
    { key: "duration", colName: "Duration", showColumn: true, formatter: "secondsToTime" },
    { key: "createdBy", colName: "Created By", showColumn: true, cssClass: "" }
  ]


  // Visa of lead 
  allVisasOfLead: any;
  allVisaOfLeadColumns: any = [
    { key: "visaId", colName: "Visa ID", showColumn: true },
    { key: "firstName", colName: "Passenger Name", showColumn: true },
    { key: "destination", colName: "Country", showColumn: true },
    { key: "visaType", colName: "Visa Type", showColumn: true },
    { key: "createDate", colName: "Application Date", showColumn: true },
    { key: "status", colName: "Status", showColumn: true },
    { key: "issueDate", colName: "Issue Date", showColumn: true },
    { key: "expiryDate", colName: "Expiry Date", showColumn: true }
  ]


  role: any;
  showQuoteButton: any;
  hideCompleteOptions: any;
  allcontactsdata: any;
  originalmailsdata: any;


  constructor(
    private _leadService: LeadsService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _itineraryService: ItineraryService,
    private _globalService: GlobalService,
    private _tasksService: TasksService,
    private _contactService: ContactsService,
    private _responseNotificationService: ResponseNotificationService,
    private _voucherService: VoucherService,
    private _lovDataService: LovDataService,
    private _reloadService: ComponentReloadService,
    private _popoverController: PopoverController,
    private _modalPopupService: ModalsService,
    private _visaService: VisaService,
    private _modalController: ModalController,
    private _callsService: CallsService,
    private _firebaseDbService: FirebaseDatabaseService,
    private _pdfServie: PdfService,
  ) {
  }

  async ngOnInit() {

    let organization = await this._globalService.getLoggedInOrgDetails();
    this.packageIds = organization.organizationDetails.packageId;
    if (this.packageIds.length === 1 && this.packageIds[0] === "PACK1006") {
      this.onlyWebsite = true;
    }

    await this.loadLovData();

    this.role = localStorage.getItem("Role");

    this._globalService.roles$.subscribe((roles) => {
      const leadModule = roles?.modules.find((module: any) => module.name === "Leads");
      this.showQuoteButton = leadModule?.permissions?.createQuote;
      this.showEditButton = leadModule?.permissions?.editLead;

      if (this.role === "ClientAccountant") {
        this.hideCompleteOptions = true;
      }
      else {
        this.hideCompleteOptions = false;
      }
      const invoiceModule = roles?.modules.find((module: any) => module.name === "Invoice & Receipts");
      if (!invoiceModule || !invoiceModule.permissions) {
        this.showInvoiceSection = false;
      } else {
        if (!invoiceModule?.permissions?.createInvoice &&
          !invoiceModule?.permissions?.viewInvoice &&
          !invoiceModule?.permissions?.editInvoice &&
          !invoiceModule?.permissions?.deleteInvoice) {
          this.showInvoiceSection = false;
        }
        else {
          this.showInvoiceSection = true;
        }
      }


      const taskModule = roles?.modules.find((module: any) => module.name === "Tasks");
      if (!taskModule || !taskModule.permissions) {
        this.hideTaskView = true;
      } else {
        this.hideTaskView = taskModule.permissions.viewTask;
        this.hideCreateTask = taskModule.permissions.createTask;

        this.tasksOptionsValues = {
          idKey: 'taskId',
          options: []
        };

        if (taskModule.permissions.viewTask) {
          this.tasksOptionsValues.options.push({ value: "View", path: "details" });
        }
        if (taskModule.permissions.editTask) {
          this.tasksOptionsValues.options.push({ value: "Edit", path: "edit" });
        }
        if (taskModule.permissions.deleteTask) {
          this.tasksOptionsValues.options.push({ value: "Delete", path: "delete" });
        }

      }
    })

    if (!this.leadIdUrl) {
      this.leadIdUrl = this._activatedRoute.snapshot.paramMap.get("leadId");
    }

    this.getLeadDetails();

    this._reloadService.reloadLeads$.subscribe(() => {
      this.getLeadDetails();
    })

    this.getDefaultVouchersForLead();
    this.getDefaultLeadQuotes();
    this.getDefaultTasks();
    this.getCallsOfLead();


    this._reloadService.reloadQuotes$.subscribe(() => {
      this.getDefaultLeadQuotes();
    })
    this._reloadService.reloadTasks$.subscribe(() => {
      this.getDefaultTasks()
    })

    this._reloadService.reloadVouchers$.subscribe(() => {
      this.getDefaultVouchersForLead()
    })
    this._reloadService.reloadTravelPref$.subscribe(() => {
      this.getLeadDetails();
    })
    this._reloadService.reloadVendorDmcsInLeadDetails$.subscribe(() => {
      this.loadallcontactsData();
    })
    this._firebaseDbService.subscribeToCallsEvent().subscribe((data: any) => {
      this.getCallsOfLead();
    }, error => {
      console.error('Error fetching data:', error);
    });
  }

  async loadLovData() {
    this._lovDataService.getLovData('TaskStatus').subscribe((data) => {
      this.taskStatusLov = data;
    })
  }

  scrollTo(section: string) {
    document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
  }

  getLeadDetails() {
    this._leadService.getLead(this.leadIdUrl).subscribe((data) => {
      this.leadDetails = data;
      if (this.leadDetails)
        this.loadallcontactsData();

      if (this.leadDetails.travelServices.length === 1 && this.leadDetails.travelServices?.includes(TRAVEL_SERVICES.VISA)) {
        this.leadForVisa = true;
        this.getVisasForLead();

        this._reloadService.reloadVisaLead$.subscribe(() => {
          this.getVisasForLead();
        })
      }
      if (this.leadDetails.itineraryId && !this.leadForVisa) {
        this.getQuoteDetails(this.leadDetails.itineraryId);
      }


      if (this.leadDetails.clientId) {
        this.getDefaultLeadsOfClinet(this.leadDetails.clientId, null);
      }

    })
  }

  getQuoteDetails(quoteId: any) {
    this._itineraryService.getQuoteData(quoteId).subscribe((data) => {
      this.quoteDetails = data.itineraryDetails;
    })
  }
  navigatePrev() {
    this._globalService.navigatePrev();
  }

  // Get default quote
  getDefaultLeadQuotes() {
    this._itineraryService.getAllItinerarysForLead(this.leadIdUrl, null, null, null).subscribe((data) => {
      this.allLeadItinerarys = data;

      if (Object.keys(this.allLeadItinerarys.data).length > 0) {
        this.showCreateQuoteButton = false;
      } else {
        this.showCreateQuoteButton = true;
      }
    })
  }

  // get default tasks
  getDefaultTasks() {
    this._tasksService.getAllTasksOfLead(this.leadIdUrl, null, null, null).subscribe((data) => {
      this.allLeadTasks = data;
      this.allLeadTasks.data = this.allLeadTasks.data.map((task: any) => ({
        ...task,
        statusLov: this.taskStatusLov
      }))
    })
  }

  taskStatusChanged(event: any) {
    let taskData = event.row;
    // Get lead data and update
    this._tasksService.getTask(taskData.taskId).subscribe((data) => {
      taskData = data;
      taskData.status = event.statusValue;
      this._tasksService.editTask(taskData.taskId, taskData).subscribe((data) => {
        this._reloadService.triggerTasksReload();
      })
    })

  }

  // Get default contacs for leads


  // Get defalut vouchers for lead
  getDefaultVouchersForLead() {
    this._voucherService.getAllVouchersForLead(this.leadIdUrl, 1, 10, null).subscribe((data) => {
      this.clientVouchers = data;
      if (this.clientVouchers.data.length > 0) {
        this.showVouchers = true;
      }

    })
  }

  getVisasForLead() {
    this._visaService.getAllVisaForLead(this.leadIdUrl, null, null).subscribe((visas) => {
      this.allVisasOfLead = visas;
      this.allVisasOfLead.data = visas.data.map((visa: any) => ({
        ...visa,
        documents: visa.documents?.map(({ imagePath, ...doc }: any) => ({
          ...doc,
          document: imagePath,
          imagePath: null
        })),
        // following property is used to make record editable from grid view
        isEditable: false
      }));

    })
  }

  async openPersonOptionsPopover(event: any) {
    const popover = await this._popoverController.create({
      component: PersonOptionsComponent,
      event: event,
      cssClass: "popup-component",
      componentProps: {
        leadDetails: this.leadDetails,
        showInvoice: this.showInvoiceSection,
        showCreateQuoteButton: this.showCreateQuoteButton,
        onPathSelected: (data: any) => this.onLeadActionOptionSelected(data), // Ensure the function is passed correctly
      }
    })
    return await popover.present()
  }

  onLeadActionOptionSelected(data: any) {

    switch (data.path) {
      case "editLead": {
        this.openEditLeadForm();
        break;
      }
      case "addInvoice": {
        // this.addInvoiceForClinet()
        break;
      }
      case "addQuote": {
        this.openQuoteItineraryForm()
        break;
      }
      case "addPassenger": {
        this.openContactForm()
        break;
      }
      case "addTask": {
        this.createTaskForLead()
        break;
      }
    }

  }

  saveLeadNotes(event: any) {
    let newNotes = this.newLeadNote.nativeElement.value;

    if (newNotes != "") {
      let updatedLeadDetails = this.leadDetails;

      let noteObj = {
        note: newNotes,
        userId: localStorage.getItem("jti"),
        createDate: this._globalService.getTodaysDateTime()
      }

      if (updatedLeadDetails.leadNotes === null || updatedLeadDetails.leadNotes.length === 0) {
        updatedLeadDetails.leadNotes = [noteObj];
      } else {
        updatedLeadDetails.leadNotes.push(noteObj);
      }

      this._leadService.updateLead(this.leadIdUrl, updatedLeadDetails).subscribe((data) => {
        this._reloadService.triggerLeadsReload();
        this.newLeadNote.nativeElement.value = "";
      })
    }
  }

  async deleteLeadNotesItem(reversedIndex: number) {
    // Calculate the original index of the note in the leadNotes array
    let tempLeadDetails = { ...this.leadDetails }
    const originalIndex = tempLeadDetails.leadNotes.length - 1 - reversedIndex;

    // Show a confirmation dialog before deleting (optional)
    const confirmDelete = await this._globalService.confirmActionPopup("Confirm to delete the note");
    if (confirmDelete) {
      // Remove the note from the leadNotes array based on the original index
      tempLeadDetails.leadNotes.splice(originalIndex, 1);

      this._leadService.updateLead(this.leadIdUrl, tempLeadDetails).subscribe((data) => {
        this._reloadService.triggerLeadsReload();
      })

    }
  }

  openContactForm() {
    this._modalPopupService.openContactForm(CONTACT_TYPES.PASSENGER, this.leadIdUrl, null, true, () => { })
  }

  // Open itinerary form model

  openQuoteItineraryForm() {
    this._modalPopupService.openItineraryForm(this.leadDetails.clientId, this.leadIdUrl, null, null, null);
  }

  openEditLeadForm() {
    this._modalPopupService.openLeadForm(this.leadIdUrl, null);
  }

  // Tasks functions
  editTask(editTaskId: any) {
    this._modalPopupService.openTasksForm(editTaskId, null, (goNew) => { });
  }

  async deleteTask(data: any) {
    if (await this._globalService.confirmActionPopup(`Are you sure to delete ${data}`, "Confirm Delete", "Yes")) {
      this._tasksService.deleteTask(data).subscribe((data) => {
        this.getDefaultTasks()
      })
    }

  }

  viewTask(data: any) {
    this._router.navigate([`tasks/details/${data}`]);
  }

  createTaskForLead() {
    this._modalPopupService.openTasksForm(null, this.leadIdUrl, (goNew) => {
      if (goNew) {
        this.createTaskForLead(); // Open a new form
        this.getDefaultTasks();
      } else {
        this.getDefaultTasks();
      }
    });
  }

  

  // get all qutoes of lead
  getAllQuotesForLead(paginationSettings: any) {
    this._itineraryService.getAllItinerarysForLead(this.leadIdUrl, paginationSettings.pageNumber, paginationSettings.pageSize, null).subscribe((data) => {
      this.allLeadItinerarys = data;
    })
  }

  // Voucher funtions
  voucherCellClicked(event: any) {
    let row = event.row;
    let clickedItem = event.clickedItem

    switch (clickedItem) {
      case "itineraryId": {
        this._modalPopupService.openReviewItineraryView(row.itineraryId, row.leadId, row.clientId);
        break;
      }
      case "voucherId": {
        this._modalPopupService.openVocuherView(row.voucherId, row.leadId, row.itineraryId);
      }
    }
  }

  async deleteVoucher(event: any) {
    if (await this._globalService.confirmActionPopup("Confirm To Delete Voucher")) {
      this._voucherService.deleteVoucher(event).subscribe((data) => {
        this.getDefaultVouchersForLead();
      })
    }
  }
  editVoucher(event: any) {
    this._voucherService.getVoucher(event).subscribe((data) => {
      this._modalPopupService.openVoucherForm(data.voucherId, data.leadId, data.itineraryId, () => { })
    })
  }
  viewVoucher(event: any) {
    this._voucherService.getVoucher(event).subscribe((data) => {
      this._modalPopupService.openVocuherView(data.voucherId, data.leadId, data.itineraryId);
    })
  }


  // Visa functions

  openVisaModal() {
    this._modalPopupService.openVisaCreationModal(this.leadIdUrl, null);
  }


  // leads of clients function
  getDefaultLeadsOfClinet(clientId: any, paginationSettings: any) {
    this._leadService.getLeadsOfClient(clientId, paginationSettings?.pageNumber, paginationSettings?.pageSize, null).subscribe((data) => {
      this.allLeadsOfClient = data;
      this.allLeadsOfClient.data = data.data.map((lead: any) => ({
        ...lead,
        fullName: `${lead.firstName} ${lead.lastName}`,
        fullPhoneNumber: lead.phoneNumber
          ? `${lead.phoneNumber.countryCode || ''} ${lead.phoneNumber.phone || ''}`
          : '',
        destinations: lead.destination ? lead.destination.map((d: any) => this._globalService.getFirstItemOfString(d.location)) : [],
        travelServices: lead.travelServices.includes(TRAVEL_SERVICES.TOUR_PACKAGE) ? TRAVEL_SERVICES.TOUR_PACKAGE : lead.travelServices

      }));
    })
  }
  VendorDmcsemails(paginationSettings: any) {
    this.originalmailsdata = this.leadDetails?.vendorDmcMailData;
    let originaldata: any = this.originalmailsdata;
    let organizedData: any = [];
    if (this.originalmailsdata) {

      this.originalmailsdata.forEach((item: any) => {
        // Split vendorIds into separate records
        if (item.vendorIds && item.vendorIds.length > 0) {
          item.vendorIds.forEach((vendorId: string) => {
            const vendorDetails = this.allcontactsdata.data.find((contact: any) => contact.vendorId === vendorId);
            organizedData.push({
              ...item,
              vendorIds: [vendorId],
              dmcIds: null,
              type: 'Vendor',
              status: 'view',
              organizationName: vendorDetails ? vendorDetails.organizationName : 'Unknown'
            });
          });
        }

        // Split dmcIds into separate records
        if (item.dmcIds && item.dmcIds.length > 0) {
          item.dmcIds.forEach((dmcId: string) => {
            const dmcDetails = this.allcontactsdata.data.find((contact: any) => contact.dmcId === dmcId);
            organizedData.push({
              ...item,
              vendorIds: null,
              dmcIds: [dmcId],
              type: 'DMC',
              status: 'view',
              organizationName: dmcDetails ? dmcDetails.organizationName : 'Unknown'
            });
          });
        }
      });

      originaldata = {
        data: organizedData,
        pageNumber: 1,
        pageSize: 10
      }
      this.allDmcVendorsEmails = originaldata;
    }
  }


  loadallcontactsData() {
    this._contactService.getVendoranddmcsContacts(-1, -1, null).subscribe((data) => {
      this.allcontactsdata = data;
      this.VendorDmcsemails(null);
    })
  }


  leadsOfClientEmittedRowClicked(event: any) {
    let row = event.row;
    let clickedItem = event.clickedItem

    switch (clickedItem) {
      case "itineraryId": {
        if (row.itineraryId) {
          this._modalPopupService.openReviewItineraryView(row.itineraryId, row.leadId, row.clientId);
        }
        break;
      }
    }
  }
  async ViewVendorDmcEmail(event: any) {
    let row = event.row;

    if (row.vendorIds) {
      const vendorContact = this.allcontactsdata.data.find((contact: any) => contact.vendorId === row.vendorIds);
      if (vendorContact) {
        row.toEmails = [vendorContact.email];
      }
    }
    // Check for DMC ID match
    else if (row.dmcIds) {
      const dmcContact = this.allcontactsdata.data.find((contact: any) => contact.dmcId === row.dmcIds);
      if (dmcContact) {
        row.toEmails = [dmcContact.email];
      }
    }

    if (!row) {
      console.error("Email data not found for event:", event);
      return;
    }
    // if row.to emails have emails but it should contain one email that amthc with this.all contactdetails. 
    const modal = await this._modalController.create({
      component: EmailpopupComponent,
      componentProps: {
        emaildata: row,
        loadData: true,
        viewOnly: true
      },
      backdropDismiss: false, // Prevents closing on clicking outside
      cssClass: 'email-modal-popup-css' // Optional: Add custom styling
    });

    await modal.present();
    modal.onDidDismiss().then((result) => {
      if (result.data?.submitted) {
        this.loadallcontactsData(); // Call this only when submit is clicked
      }
    });
  }

  // Calls of lead functions
  getCallsOfLead(paginationSettings: any = null) {
    this._callsService.getCallsOfLeads(this.leadIdUrl, paginationSettings?.pageNumber, paginationSettings?.pageSize).subscribe((allLeads) => {
      this.allCallsOfLead = allLeads;
    })
  }

  // quote Grid funtions

  onOptionSelected(event: any) {
    let path = event.path;
    let row = event.row;

    switch (path) {
      case TABLE_OPTION_VALUES.DELETE: {
        this.deleteQuote(row.itineraryId)
        break;
      }
      case TABLE_OPTION_VALUES.EDIT: {
        this.editQuote(row.itineraryId, row.leadId, row.clientId)
        break;
      }
      case TABLE_OPTION_VALUES.FINALIZE: {
        this.finalizeQuote(row.itineraryId, row.leadId, row.clientId)
        break;
      }
      case TABLE_OPTION_VALUES.FINALIZE_AND_CONVERT: {
        this.finalizeAndConvertQuote(row.itineraryId, row.leadId, row.clientId)
        break;
      }
      case TABLE_OPTION_VALUES.CONVERT: {
        this.convertQuote(row.itineraryId, row.leadId)
        break;
      }
      case TABLE_OPTION_VALUES.DOWNLOAD: {
        this.downloadQuoteAsPdf(row.itineraryId);
        break;
      }
      case TABLE_OPTION_VALUES.MAKE_A_CLONE: {
        this.cloneQuoteForNewLead(row.itineraryId);
        break;
      }
    }
  }

  onTableCellClicked(event: any) {
    let row = event.row;
    let column = event.column;

    switch (column) {
      case "itineraryId": {
        this.viewQuote(row.itineraryId, row.leadId, row.clientId, row.status);
        break;
      }
      case "leadId": {
        this._router.navigate(['/leads/details', row.leadId]);
        break;
      }
    }

  }

  editQuote(quoteId: any, leadId: any, clientId: any) {
    this._modalPopupService.openItineraryForm(clientId, leadId, quoteId, null, null)
  }

  async deleteQuote(quoteId: any) {
    if (await this._globalService.confirmActionPopup(`Are you sure to delete ${quoteId}`, "Confirm Delete", "Yes")) {
      this._itineraryService.deleteQuote(quoteId).subscribe((data) => {
        this._responseNotificationService.showMessage("Quote Deleted Successfully!")
        this._reloadService.triggerQuotesReload();
      })
    }
  }

  finalizeQuote(quoteId: any, leadId: any, clientId: any) {
    this.checkAndFinalizeQuote(quoteId, leadId, clientId)
  }

  convertQuote(quoteId: any, leadId: any) {
    this._itineraryService.getQuoteData(quoteId).subscribe((data) => {

      if (data.itineraryDetails.status !== "Confirmed") {
        this._responseNotificationService.showMessage("Quote not yet confirm!", true);
      } else {
        this.openInvoiceVoucherModal(quoteId, leadId);
      }
    })
  }

  finalizeAndConvertQuote(quoteId: any, leadId: any, clientId: any) {
    this._modalPopupService.openReviewItineraryView(quoteId, leadId, clientId);
  }

  viewQuote(itineraryId: any, leadId: any, clientId: any, status: any) {
    if (status === RECORD_STATUS_VALUES.DRAFT) {
      this._modalPopupService.openItineraryForm(clientId, leadId, itineraryId, null, null)
    } else {
      this._modalPopupService.openReviewItineraryView(itineraryId, leadId, clientId);
    }
  }

  downloadQuoteAsPdf(quoteId: any) {
    this._itineraryService.getQuoteTemplateHtml(quoteId).subscribe((quoteAsHtml) => {
      this._pdfServie.generatePdf(quoteAsHtml, true).subscribe(
        (blob) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = `Quote_${quoteId}.pdf`;
          link.click();
          URL.revokeObjectURL(link.href);
        },
        (error) => {
          console.error('Error generating PDF:', error);
        }
      );
    })
  }

  // Check if quote if fit to convert into quote and then finalize
  async checkAndFinalizeQuote(quoteId: any, leadId: any, clientId: any) {
    this._modalPopupService.openReviewItineraryView(quoteId, leadId, clientId);
  }

  openInvoiceVoucherModal(quoteId: any, leadId: any) {
    this._modalPopupService.openVoucherForm(null, leadId, quoteId, () => { })
  }

  // Clone Quote for new lead
  cloneQuoteForNewLead(itineraryId: any) {
    this._modalPopupService.openItineraryForm(null, null, null, null, null, itineraryId);
  }

  // Quote Grid functions end

  replaceLineBreakWithbreakTag(str: string): string {
    return str ? str.replace(/\n/g, '<br>') : '';
  }
}
